import 'core-js/modules/es.array.concat.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

var Atlas = function Atlas(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? '40' : _ref$size,
    inverted = _ref.inverted;
  return jsxs("svg", {
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-cognite-logo', 'cogs-graphic', 'cogs-graphic--cdf'].concat(getThemeClassNames(inverted))),
    children: [jsx("title", {
      children: "Atlas product logo"
    }), jsx("path", {
      d: "M2.25 13.59C2.25 7.32709 7.32709 2.25 13.59 2.25H22.41C22.41 8.51291 17.3329 13.59 11.07 13.59H2.25Z",
      fill: "#491D8B"
    }), jsx("path", {
      d: "M33.75 22.41C33.75 28.6729 28.6729 33.75 22.41 33.75H13.59C13.59 27.4871 18.6671 22.41 24.93 22.41H33.75Z",
      fill: "#491D8B"
    }), jsx("path", {
      d: "M33.75 22.41C27.4871 22.41 22.41 17.3329 22.41 11.07V2.25C28.6729 2.25 33.75 7.32709 33.75 13.59V22.41Z",
      fill: "#6929C4"
    }), jsx("path", {
      d: "M13.59 33.75C7.32709 33.75 2.25 28.6729 2.25 22.41V13.59C8.51291 13.59 13.59 18.6671 13.59 24.93V33.75Z",
      fill: "#6929C4"
    })]
  });
};

export { Atlas };
